ui-bank-search-intro {
  display: block;
  position: relative;
  padding: $sd-spacing-20 4.5vw $sd-spacing-16;

  @include breakpoint($desktop) {
    display: flex;
    align-items: center;
    padding: 7.5rem $sd-spacing-4;
  }

  .sd-headline.primary {
    display: block;
    text-align: center;
    color: $sd-textColor-primary-DEFAULT;
  }

  @include breakpoint($xlarge) {
    height: var(--map-height-desktop);
  }

  ui-bank-search-intro-step {
    position: relative;
    margin-left: auto;
    margin-right: auto;

    ui-bank-search-autocomplete {
      position: relative;
      margin: 0 auto;
      max-width: 320px;

      input {
        padding-right: 4.6875rem;
      }

      .search-trigger {
        cursor: pointer;
        position: absolute;
        height: 3rem;
        width: 2.5rem;
        top: 0;
        right: 0;
      }

      &.fixed {
        position: absolute;
        width: 100%;
        max-width: 100%;
        top: -12.1875rem;
        left: 0;

        @include breakpoint($desktop) {
          max-width: 335px;
          top: -5rem;
          left: -0.3125rem;
        }

        @include breakpoint($xlarge) {
          top: -9.375rem;
        }
      }
    }

    ui-bank-search-intro-current-location {
      sd-button::part(base) {
        width: 100%;
      }
    }

    p {
      font-size: $sd-fontSize-sm;
      line-height: $sd-lineHeight-normal;
      margin: $sd-spacing-4 0;
    }

    &:first-of-type {
      max-width: 580px;

      @include breakpoint($desktop) {
        margin: 0 25px;
        max-width: none;
      }
    }

    &:nth-of-type(2) {
      --icon-scale-delay: 0.5s;
    }

    &:last-of-type {
      --icon-scale-delay: 1s;
    }

    &:not(:first-of-type) {
      max-width: 280px;

      @include breakpoint($desktop) {
        margin: 0 $sd-spacing-6;
        min-width: 200px;
        max-width: none;
      }
    }

    &:not(:last-of-type) {
      margin-bottom: $sd-spacing-20;

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        bottom: -2.875rem;
        height: 1.875rem;
        width: 0.125rem;
        background-color: $sd-backgroundColor-white;
      }
    }

    > :not(:last-child) {
      margin-bottom: $sd-spacing-4;
    }

    @include breakpoint($desktop) {
      margin: 0 $sd-spacing-6;

      &:not(:last-of-type) {
        margin-bottom: 0;

        &::after {
          left: auto;
          bottom: auto;
          top: 50%;
          right: -3rem;
          height: 0.125rem;
          width: 2.875rem;
        }
      }
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
